// src/App.js
import React from "react";
import IframeHost from "./IframeHost";

function App() {
  return (
    <div className="App">
      <IframeHost />
    </div>
  );
}

export default App;
